import type { APIKEYS_ERROR_CODES } from "@amtana/apikeys-contract";
import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";

const EN = {
  notFoundTitle: "This key no longer exists",
  notFoundDescription: "It may already have been revoked. Reload the list to see what remains.",
} as const;

const ES: Translation<typeof EN> = {
  notFoundTitle: "Esta clave ya no existe",
  notFoundDescription: "Puede que ya la hayan revocado. Recarga la lista para ver cuáles quedan.",
};

export const API_KEY_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const API_KEYS_ERROR_COPY = {
  apikeys_not_found: {
    title: phrase(API_KEY_ERROR_CATALOGS, "notFoundTitle"),
    description: phrase(API_KEY_ERROR_CATALOGS, "notFoundDescription"),
  },
} satisfies ErrorCopyFor<typeof APIKEYS_ERROR_CODES>;
